import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { DashboardQuickActionsSuccess } from '~/services/api/generated'

type QuickActionsData = DashboardQuickActionsSuccess['data']

const emptyQuickActions = (): QuickActionsData => ({
  completion: { completed: 0, percentage: 0, total: 0 },
  recommended_tasks: { completed: [], important: [], required: [], suggested: [] }
})

export const useDashboardQuickActionsStore = defineStore('dashboardQuickActions', () => {
  const data = ref<QuickActionsData>(emptyQuickActions())
  const isLoaded = ref(false)
  const isLoading = ref(false)

  // Owns the spinner too: a superseded load leaves its own `finally` write unmade.
  const reset = () => {
    data.value = emptyQuickActions()
    isLoaded.value = false
    isLoading.value = false
  }

  return { data, isLoaded, isLoading, reset }
})
